import React from "react";
import CloseSvg from "./close.inline.svg";

const CloseIcon = ({ size = 10 }) => (
  <CloseSvg width={size} height={size}/>
);

export default CloseIcon;
